import styles from './customAnchorTag.scss';

const customAnchorTag = (props) => {
    const showAnchorTag = props.isSemiBold ? <span className={styles.sceAnchorTagSemiBold}>{props.linkName}</span> : props.isBold ? <span className={styles.sceAnchorBold}> {props.linkName} </span> : props.linkName;
    let ariaLabelAttribute=(props.linkName==='')?{'aria-label':"Empty Link"}:'';
    return (
        <a onClick={props.onClick} target={props.sceLearnMore ? '_blank' : ''} 
            name={props.name} className={(props.isUnderline 
                ? [styles.sceAnchorTagUnderline, props.className].join(" ") 
                : styles.sceAnchorTag + ' ' + props.className +' '+[props.sceLearnMore? styles.sceLearnMoreButton:'']) +' ' + [props.visibleInBlue? styles.sceAnchorTagblue: '']} 
            id={props.id} href={!props.link ? "javascript:void(0)" : props.link} 
            data-toggle={props.dataToggle} data-target={props.dataTarget} {...ariaLabelAttribute}>{showAnchorTag}</a>
        );
};
customAnchorTag.defaultProps = {
    sceLearnMore:false,
};
export default customAnchorTag;
